import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("ROLES");
const CRUD_ACTION_HANDLERS = getActionHandler("ROLES");

export default function roles(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
